var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-receive-badge',{attrs:{"name":"w1d3badge1","bg-path":"/images/game/w1d3/w1d3_badge_bg.png","bubble-text":_vm.$lang.get('w1d3.badge1', {br: '\n'})}})}
var staticRenderFns = []

export { render, staticRenderFns }